import React from 'react'
import { image, avatarBackground } from 'core/utils'
import {onAnchorClick} from 'core/hooks/useNuxtProfileRedirect';
const Avatar = ({ user, isActive, onClick }) => {
  const { username = 'me' } = user // current user profile not available upon initial load - TODO: check with Kevin
  const src = image(user) || 'nophoto'
  let nuxtHref, nuxtPathname = ''
  if (CONFIG.isNuxt) {
    const profileUrl = CONFIG.urls.profile(user)
    if (profileUrl) {
      nuxtHref = new URL(profileUrl, window.location.origin)
      nuxtPathname = nuxtHref.pathname
    }
  }
  const url = el =>
    !isActive
      ? el
      : <a className="avatar-link" href={CONFIG.isNuxt ? nuxtPathname : CONFIG.urls.profile(user)} onClick={CONFIG.isNuxt ? e => onAnchorClick(e, nuxtHref, nuxtPathname, user) : undefined}>{el}</a>
  if (src.includes('nophoto')) {
    return url(
      <div className="avatar" onClick={onClick} style={{ backgroundColor: avatarBackground(username)}}>
        {username[0]}{(username.match(/[^A-Z][A-Z]|[-_\.\d\s][a-z]/) || [username])[0][1]}
      </div>
    )
  }
  return url(<img className="avatar" src={src} onClick={onClick}/>)
}

export default Avatar
